import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  Screen,
  TextInput,
  ValidatePassword,
  isPasswordStrong,
} from '~/atomic';
import modalStatusService from '~/services/modalStatus';
import { useAppDispatch } from '~/store';
import { changeMyPassword } from '~/store/user/thunks';

interface FormData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export default function UpdatePasswordView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { control, handleSubmit, watch } = useForm<FormData>({
    defaultValues: { currentPassword: '', newPassword: '', confirmPassword: '' },
  });
  const newPassword = watch('newPassword');

  const onSubmit = async (data: FormData) => {
    if (!isPasswordStrong(data.newPassword)) return;
    if (data.newPassword !== data.confirmPassword) return;
    const ok = await dispatch(
      changeMyPassword({
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
      }),
    ).unwrap();
    modalStatusService.show({
      type: ok ? 'success' : 'error',
      title: ok ? 'Senha alterada!' : 'Não foi possível atualizar',
      description: ok
        ? 'Sua senha foi atualizada com sucesso.'
        : 'Verifique sua senha atual e tente novamente.',
      textFirstButton: 'Ok',
      showFirstButton: true,
      onClickFirstButton: () => {
        modalStatusService.hide();
        if (ok) navigate(-1);
      },
      handleCloseModal: modalStatusService.hide,
    });
  };

  return (
    <Screen headerTitle="Alterar senha">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-medium py-medium">
        <TextInput control={control} name="currentPassword" label="Senha atual" icon="icon-security" secureTextEntry />
        <TextInput control={control} name="newPassword" label="Nova senha" icon="icon-security" secureTextEntry />
        <TextInput control={control} name="confirmPassword" label="Confirmar nova senha" icon="icon-security" secureTextEntry />
        <ValidatePassword value={newPassword} />
        <Button type="submit" fullWidth text="Salvar nova senha" />
      </form>
    </Screen>
  );
}
